import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";

import { Container, Text, BodyLarge, Icon, Tabs, View } from "./base";

type Tab = {
  id: string;
  label: string;
};

type PageLayoutProps = {
  title: string;
  description?: string;
  children: ReactNode;
  backTo?: string;
  backLabel?: string;
  headerAction?: ReactNode;
  tabs?: Tab[];
  activeTab?: string;
  onTabChange?: (tabId: string) => void;
  tabAction?: ReactNode;
};

export const PageLayout = ({ title, description, children, backTo, backLabel, headerAction, tabs, activeTab, onTabChange, tabAction }: PageLayoutProps) => {
  const navigate = useNavigate();

  return (
    <div className="w-full min-h-full bg-white dark:bg-slate-900">
      <Container
        size="xl"
        className="py-8 min-h-full"
      >
        <div>
          {backTo && (
            <button
              type="button"
              onClick={() => navigate(backTo)}
              className="flex items-center gap-1 text-sm text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 mb-4"
            >
              <Icon
                name="chevron-left"
                size={14}
                className="text-gray-400 dark:text-gray-500"
              />
              {backLabel || "Back"}
            </button>
          )}
          <View className="flex items-center justify-between">
            <div>
              <Text className="font-bold text-3xl mb-2">{title}</Text>
              {description && <BodyLarge className="!text-sm">{description}</BodyLarge>}
            </div>
            {headerAction}
          </View>
        </div>

        {tabs && activeTab && onTabChange && (
          <View className="mt-4 border-b border-gray-200 dark:border-gray-700 flex items-center justify-between -mx-1">
            <Tabs
              tabs={tabs}
              activeTab={activeTab}
              onChange={onTabChange}
            />
            {tabAction}
          </View>
        )}

        {children}
      </Container>
    </div>
  );
};
